import { MapBounds } from "movisat-maps";

export class CuadriculaModel {
    id: number;
    nombre: string = '';
    ancho: number = 0;
    alto: number = 0;
    marco: MapBounds;
    empresa: number;
}